import React, {Component} from 'react';
import { MuiThemeProvider } from "material-ui/styles";
import { IconButton, AppBar } from 'material-ui'
import { CommunicationVpnKey } from 'material-ui/svg-icons'

class LoggedToolbarButtons extends Component {

    render() {
        return (
            <IconButton>
                <CommunicationVpnKey color={"white"} />
            </IconButton>
        )
    }
}

class ToolbarButtons extends Component {

    render() {
        return (
            <IconButton>
                <CommunicationVpnKey color={"white"} />
            </IconButton>
        )
    }
}

class App extends Component {
    state = {
        logged: false
    };

    render() {
        return (
            <MuiThemeProvider>
                <AppBar
                    title={"Notepad2"}
                    iconElementRight={
                        this.state.logged ? <LoggedToolbarButtons/> : <ToolbarButtons/>
                    }
                />


            </MuiThemeProvider>
        )
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js